import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

// Shared translate control button. Pairs with useContentTranslation.
// Translation is open to everyone (owner decision 2026-11-05), guests included.
export const TranslateToggle = ({ translating, slow = false, hasTranslation, showOriginal, onToggle, testid = "translate-toggle", className = "", style, size = 12 }) => {
  const { t } = useTranslation();
  const label = translating
    ? (slow ? t("common.translatingSlow") : t("common.translating"))
    : (!hasTranslation ? t("common.translate") : (showOriginal ? t("common.seeTranslation") : t("common.seeOriginal")));
  const handle = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    onToggle(e);
  };
  return (
    <>
      <button
        type="button"
        data-testid={testid}
        onClick={handle}
        disabled={translating}
        style={style}
        className={`flex items-center gap-1 text-xs font-medium disabled:opacity-60 ${className}`}
      >
        <Globe size={size} className={translating ? "animate-spin" : ""} /> {label}
      </button>
    </>
  );
};

export default TranslateToggle;
